import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  my: (p) => p.spacing(2),
  fontSize: (p) => p.typography.body2.fontSize,
  color: (p) => p.palette.grey[400],
};
